<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { type ComputedColumnInterface } from '../../DefaultTableInterfaces'
import HeaderSort from './DefaultTableHeaderSort.vue'

export default defineComponent({
  props: {
    column: {
      type: Object as PropType<ComputedColumnInterface>,
      required: true,
    },
    sortField: {
      type: String,
      required: true,
    },
    sortOrder: {
      type: Boolean as PropType<boolean>,
    },
    onSort: {
      type: Function as PropType<() => void>,
    },
    enableSorting: {
      type: Boolean,
    },
  },
  setup(props) {
    return () => (

      <div class="ark-ui-table-text-header">
        <div class="ark-ui-table-text-header-text">{ props.column.name }</div>

        { props.enableSorting && props.onSort && (
          <HeaderSort column={props.column} onSort={props.onSort} sortField={props.sortField} sortOrder={props.sortOrder}/>
        ) }
      </div>

    )
  },
})
</script>

<style lang="scss" scoped>
.ark-ui-table-text-header {
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 24px;
  padding: 12px 16px;

  &-text {
    align-self: center;
    min-width: 40px;
    margin-right: 13px;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    color: #585B69;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
  }

  &.active,
  &:hover {
    & path {
      fill: #585B69;
    }
  }
}
</style>
